import api from "./api";

// CRUD admin do catálogo de conectores (Everlog Admin) — PO1-2560/2561.
// Endpoints no backend_hub sob /catalogo/*. Guarda de admin é no backend.

// ── Conectores ──────────────────────────────────────────────────────────────
export async function listarConectores() {
  const { data } = await api.get("/catalogo/conectores");
  return data;
}

export async function criarConector(payload) {
  const { data } = await api.post("/catalogo/conectores", payload);
  return data;
}

export async function atualizarConector(id, payload) {
  const { data } = await api.put(`/catalogo/conectores/${id}`, payload);
  return data;
}

// ── Config global (ConectorParametro) ───────────────────────────────────────
export async function getConfig(idConector) {
  const { data } = await api.get(`/catalogo/conectores/${idConector}/config`);
  return data;
}

export async function salvarConfig(idConector, valores) {
  const { data } = await api.put(`/catalogo/conectores/${idConector}/config`, { valores });
  return data;
}

// ── Definições de campo (Parametro/UiConfig) ────────────────────────────────
export async function getCampos(conectorKey) {
  const { data } = await api.get(`/catalogo/conectores/${conectorKey}/campos`);
  return data;
}

export async function criarCampo(conectorKey, payload) {
  const { data } = await api.post(`/catalogo/conectores/${conectorKey}/campos`, payload);
  return data;
}

export async function atualizarCampo(idParametro, payload) {
  const { data } = await api.put(`/catalogo/campos/${idParametro}`, payload);
  return data;
}

// ── Lookups (TipoProtocolo / TipoValidacao) ─────────────────────────────────
export async function getTiposProtocolo() {
  const { data } = await api.get("/catalogo/tipos-protocolo");
  return data;
}

export async function getTiposValidacao() {
  const { data } = await api.get("/catalogo/tipos-validacao");
  return data;
}

export async function criarTipoProtocolo(payload) {
  const { data } = await api.post("/catalogo/tipos-protocolo", payload);
  return data;
}

export async function criarTipoValidacao(payload) {
  const { data } = await api.post("/catalogo/tipos-validacao", payload);
  return data;
}

// ── Vínculo TransportadoraConector ──────────────────────────────────────────
export async function getVinculos(idTransportadora) {
  const { data } = await api.get(`/catalogo/transportadoras/${idTransportadora}/conectores`);
  return data;
}

export async function criarVinculo(idTransportadora, payload) {
  const { data } = await api.post(`/catalogo/transportadoras/${idTransportadora}/conectores`, payload);
  return data;
}

export async function atualizarVinculo(id, payload) {
  const { data } = await api.put(`/catalogo/transportadora-conector/${id}`, payload);
  return data;
}
